import { useMemo } from 'react'
import { useSelectOppStages } from '@user/store/salesFunnel'
import { useCwqClosedLostEnabled } from '@user/components/Opportunities/hooks/useCwqClosedLostEnabled'

import { Props } from '../OpportunityStatusSelect'

export function useData(props: Props) {
  const { salesFunnelId } = props

  const [allStages, closedWonStageId, closedLostStageId] =
    useSelectOppStages(salesFunnelId)

  const cwqClosedLostEnabled = useCwqClosedLostEnabled(props.soldServiceStatus)
  const inCwqClosedLostMode =
    cwqClosedLostEnabled && props.salesFunnelStageId === closedWonStageId

  const disabled = inCwqClosedLostMode
    ? false
    : props.disabled ||
      props.salesFunnelStageId === closedLostStageId ||
      props.salesFunnelStageId === closedWonStageId

  const salesFunnelStages = useMemo(() => {
    if (!inCwqClosedLostMode) return allStages
    return allStages.filter(
      (s) => s.id === closedWonStageId || s.id === closedLostStageId,
    )
  }, [inCwqClosedLostMode, allStages, closedWonStageId, closedLostStageId])

  const lockedStageId = inCwqClosedLostMode ? closedWonStageId : undefined

  return {
    closedLostStageId,
    closedWonStageId,
    disabled,
    salesFunnelStages,
    lockedStageId,
  }
}
